export const environment = {
  production: false,
  host: 'https://api.grupofleury.com.br',
  apiFichas: '',
  aesSecret: 'Fleury@2021#EnvioResultadoEmailP',
  aesIv:'Fleury@21EnvResP',
  auth: {
    client_id: 'ec48cbac-a4cc-338f-8be1-52a1fe180485',
    client_secret: 'dba7ea07-b5d3-3fea-b191-a4b9e12b53eb',
    authorization: 'ZWM0OGNiYWMtYTRjYy0zMzhmLThiZTEtNTJhMWZlMTgwNDg1OmRiYTdlYTA3LWI1ZDMtM2ZlYS1iMTkxLWE0YjllMTJiNTNlYg==',
    loginUrl: 'https://web-identidade-ps-corporativo.apps.grupofleury.com.br',
    redirectUri: 'https://localhost'
  },
  settings: {
    pageLimit: 10,
    dataLimit: 5
  }
};
